import DataHelpers from '../helpers/DataHelpers'
import FirebaseHelpers from '../helpers/FirebaseHelpers'
import FireData from '../data/FireData'
import NiceData from '../data/NiceData'
import Store from '../store/Store'

export default class {
    static setApplicationData(name, value) {
        Store.commit('setApplicationData', {name, value})
    }

    static getApplicationData(name) {
        return Store.getters.getApplicationData(name)
    }

    static clearApplicationData() {
        Store.commit('clearApplicationData')
    }       
}


// WEBPACK FOOTER //
// ./src/helpers/AppHelpers.js